<template>
	<div>
		<Head1 :titleVal="$t('components.head1.title.forget')"  :type="type"></Head1>
		<div class="mainArea">
			<div class="tabArea">
					<div class="tabli" :class="selectedTab == 0 ? 'active' : ''" >{{$t('pages.forget.tab_verify')}}</div>
					<div class="tabli" :class="selectedTab == 1 ? 'active' : ''" >{{$t('pages.forget.tab_reset')}}</div>
					<div class="tabli" :class="selectedTab == 2 ? 'active' : ''" >{{$t('pages.forget.tab_done')}}</div>				
			</div>
			
			<div v-if="selectedTab == 0" class="tabContent">
				<div class="label">{{$t('pages.forget.label_mobile')}}<span class="redText">*</span></div>
				<div class="inputArea">
					<input type="text" :placeholder="$t('pages.forget.placeholder_mobile')" class="telInput" v-model="form.mobile"/>
				</div>				
				<div class="label">{{$t('pages.forget.label_code')}}<span class="redText">*</span></div>
				<div>
					<input type="text" class="codeInput" :placeholder="$t('pages.forget.placeholder_code')" v-model="form.checkcode"/>
					<button class="codeBtn" v-if="!isCountdown" @click="startCountdown(60)">{{$t('pages.forget.get_code')}}</button>
					<button class="codeBtn" v-if="isCountdown" disabled>{{$t('pages.forget.re_send_seconds',{count: countdown})}}</button>
				</div>
				<div class="nextBtn" @click="tabClick(1)" >{{$t('pages.forget.next')}}</div>
			</div>
			<div v-if="selectedTab == 1" class="tabContent">
				<div class="label">{{$t('pages.forget.label_newpwd')}}<span class="redText">*</span></div>
					<div class="inputArea">
						<input type="password" :placeholder="$t('pages.forget.placeholder_newpwd')" class="telInput" v-model="form.newpassword"/>
					</div>
					<div class="label">{{$t('pages.forget.label_confirmpwd')}}<span class="redText">*</span></div>
					<input type="password" :placeholder="$t('pages.forget.placeholder_confirmpwd')" class="telInput" v-model="form.confirmpwd"/>
					<div class="nextBtn" @click="ChangePwd">{{$t('pages.forget.confirm')}}</div>
			</div>
			<div v-if="selectedTab == 2"  class="tabContent tabCenter">
				<img src="../assets/images/ok.png"/>
				<div class="successText">{{$t('pages.forget.success_text')}}</div>
				<div class="successTextSmall">{{$t('pages.forget.auto_redirect',{count: countdown2})}}</div>
				<router-link to="/"><div class="smallBtn">{{$t('pages.forget.go_login')}}</div></router-link>

			</div>
		</div>
		<Foot1></Foot1>
	</div>
	
</template>

<script>
	import Head1 from '../components/head1.vue';
	import Foot1 from '../components/foot1.vue';
	export default{
		components:{
			Head1,
			Foot1
		},
		data() {
			return {
				titleStr: '找回密码',
				type:'FORGET',
				selectedTab:0,
				countdown: 0, // 初始倒计时秒数
				countdown2: 0, // 初始倒计时秒数
				isCountdown: false,
				timer: null, // 计时器
				form:{
					mobile:'',
					checkcode:'',
					newpassword:'',
					confirmpwd:''
				}
			}			
		},
		methods: {
			tabClick(idx){
				if(idx==1)
				{
					if(this.form.mobile=='')
					{
						this.$message({message: this.$t('pages.forget.msg_enter_mobile'),type: "warning"});
						return;
					}
					if(this.form.checkcode=='')
					{
						this.$message({message: this.$t('pages.forget.msg_enter_code'),type: "warning"});
						return;
					}
				}	
				if(idx == 2){
					this.countdown2 = 5; // 倒计时5秒
					this.startCountdown2();
				}
				this.selectedTab = idx;
			},
			startCountdown2() {
			 //  if (this.countdown2 > 0) {
				// return; // 倒计时中，不执行点击操作
			 //  }
			  // 开始倒计时，设置计时器  
			  this.timer = setInterval(() => {
				if (this.countdown2 > 0) {
				  this.countdown2 -= 1;
				} else {
				  clearInterval(this.timer); // 倒计时结束，清除计时器
				  this.$router.push({ name: "LoginVue" });
				}
			  }, 1000);
			},
			startCountdown(seconds) {

				this.$scUtil.axiosPut(this, 'CommonApi/Execute', {
					cellphone: this.form.mobile,
					operate: 'sendsms',
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.$message({message: res.message,type: "success"});
						this.isCountdown = true;
						this.countdown = seconds;

					}else
					{
						this.$message({message: res.message,type: "warning"});
					}

				});
			  const interval = setInterval(() => {
				if (this.countdown > 0) {
				  this.countdown -= 1;
				} else {
				  clearInterval(interval);
				  this.isCountdown = false;
				}
			  }, 1000);
			},
			ChangePwd()
			{
				if(this.form.newpassword=='')
				{
					this.$message({message: this.$t('pages.forget.msg_newpwd_required'),type: "warning"});
					return;
				}
				if(this.form.confirmpwd=='')
				{
					this.$message({message: this.$t('pages.forget.msg_confirmpwd_required'),type: "warning"});
					return;
				}
				this.$scUtil.axiosPut(this, 'MemberApi/ForgetPwd', {
					cellphone: this.form.mobile,
					checkCode: this.form.checkcode,
					newpassword: this.form.newpassword,
					confirmpwd: this.form.confirmpwd,
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.$message({message: this.$t('pages.forget.msg_reset_success'),type: "success"});
						this.selectedTab = 2;
						this.countdown2 = 5; // 倒计时5秒
						this.startCountdown2();
				
					}else
					{
						this.$message({message: res.message,type: "warning"});
						this.selectedTab = 0;
					}
				
				});
			}
		}
	}
</script>

<style scoped>
	
	
	.tabArea{
		display: flex;
		align-items: center;
		width: 1201px;
		margin-top: 46px;
	}
	
	.tabli{
		flex:1;
		height: 52px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size:18px;
		color: #999999;
		background-color: #f3f3f3;
		margin-right: 5px;
	}
	
	.tabli:nth-child(3){
		margin-right: 0px;
	}
		
	.tabli.active{
		background-color: #0380fe;
		color: #fff;
	}
	
	.mainArea{
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-bottom: 130px;
	}
	
	
	.label{
		font-size: 15px;
		color: #333333;
		width: 415px;
		text-align: left;
		margin-bottom:  16px;
	}
	
	.telInput{
		width: 415px;
		height: 50px;
		border: 1px solid #cdcdcd;
		padding: 0 11px;
		font-size: 13px;
		color: #000;
		box-sizing: border-box;
	}
	
	.telInput::placeholder,
	.codeInput::placeholder{
	  color: #888888;
	  font-size: 13px;
	}
	
	.inputArea{
		margin-bottom:35px;
	}
	
	.codeBtn{
		width: 140px;
		height: 49px;
		border: 1px solid #0380fe;
		color: #333333;
		font-size: 14px;
		background-color: #fff;
		cursor: pointer;
	}
	
	.codeInput{
		width: 262px;
		height: 49px;
		border:1px solid #cdcdcd;
		margin-right:13px;
		padding: 0 11px;
		box-sizing: border-box;
	}
	
	input:focus{
		outline: none;
	}
	
	.nextBtn{
		width: 415px;
		height: 53px;
		text-align: center;
		line-height: 53px;
		background-color: #0380fe;
		border: 1px solid #0380fe;
		color: #fff;
		font-size: 20px;
		margin-top:47px;
		cursor: pointer;
		border-radius: 10rpx;
	}
	
	.tabContent{
		margin-top: 63px;
	}
	
	.tabCenter{
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	.redText{
		color:#db050f;
	}
	
	.smallBtn{
		width: 185px;
		height:51px;
		background-color: #0380fe;
		text-align: center;
		line-height:51px;
		color:#fff;
	}
	
	.successText{
		font-size: 22px;
		color: #333333;
		margin-bottom: 18px;
		margin-top: 35px;
	}
	
	.successTextSmall{
		font-size: 13px;
		color: #333333;
		margin-bottom: 32px;
	}
	
	.blue{
		color: #0380fe;
	}
	
	.setRight{
		margin-left: 5px;
	}
</style>